import { TrackingCommand } from './TrackingInterface'

/**
 * Composite for managing and executing a collection of tracking commands.
 * Implements the Composite Pattern for uniform handling of commands and collections of commands.
 */
export class TrackingComposite implements TrackingCommand {
  private commands: TrackingCommand[] = []

  /**
   * Add a tracking command or composite to the collection.
   * @param command - A single TrackingCommand or composite.
   */
  add(command: TrackingCommand): void {
    this.commands.push(command)
  }

  /**
   * Remove a specific tracking command from the collection.
   * @param command - The command to remove.
   */
  remove(command: TrackingCommand): void {
    this.commands = this.commands.filter((c) => c !== command)
  }

  /**
   * Clear all commands from the composite.
   */
  clear(): void {
    this.commands = []
  }

  /**
   * Execute all commands in the collection with the provided data.
   * @param data - The data to pass to each command.
   */
  execute(data: any): void {
    this.commands.forEach((command) => command.execute(data))
  }

  /**
   * Get the total number of commands in the composite.
   * @returns The count of commands.
   */
  size(): number {
    return this.commands.length
  }
}
